export const PROCESSES = {
  BOOKING: 'booking',
  LISTING: 'listing'
};
